import "./Gartenpflege.module.css";
import Header from "@/reusable_sections/Header";
import YourGardenOurCare from "./sections/YourGardenOurCare";
import OurGardenMaintenanceServices from "./sections/OurGardenMaintenanceServices";
import Footer from "@/reusable_sections/Footer";
import SeoMeta from "./sections/SeoMeta";
export default function GartenpflegePage() {
  return <div>
      <SeoMeta />
      <Header />
      <YourGardenOurCare />
      <OurGardenMaintenanceServices />
      <Footer />
    </div>;
}